import { ArrowUpRightFromCircle, Calendar, Clock, Laptop, ParkingMeter, Watch } from "lucide-react";
import React, { useEffect, useState } from "react";
const eventsData = [
  {
    title: "Data Science with Python",
    
    time: "07:00 PM",
    duration: "120 Minutes",
    mode: "Live",
    image: "https://picsum.photos/400/550?random=500",
    date:"2026-03-16T17:00:12"
  },
  {
    title: "Mobile App Dev Bootcamp",
   
    time: "06:00 PM",
    duration: "150 Minutes",
    mode: "Live",
    image: "https://picsum.photos/400/550?random=501",
    date:"2026-01-22T17:00:40"
  },
  {
    title: "AI & Machine Learning Basics",
    date: "13 April 2025",
    time: "05:30 PM",
    duration: "180 Minutes",
    mode: "Live",
    image: "https://picsum.photos/400/550?random=502",
    date:"2026-02-26T17:00:45"
  }
];

const EventCard1= () => {
  function formatDate(input) {
  const arr = input.includes('-') ? input.split('-') : input.split('/');
  const months = ["January","February","March","April","May","June",
                  "July","August","September","October","November","December"];
  
  const [year,month, day ] = arr;
  return `${parseInt(day)} ${months[month - 1]} ${year}`;
}
  // Countdown Utility
function getTimeLeft(targetISO) {
  const total = Date.parse(targetISO) - Date.now();
  if (total <= 0) {
    return { d: 0, h: 0, m: 0, s: 0, expired: true };
  }

  const d = Math.floor(total / (1000 * 60 * 60 * 24));
  const h = Math.floor((total / (1000 * 60 * 60)) % 24);
  const m = Math.floor((total / (1000 * 60)) % 60);
  const s = Math.floor((total / 1000) % 60);

  return { d, h, m, s, expired: false };
}
const [timers, setTimers] = useState(
    eventsData.map((ev) => getTimeLeft(ev.date))
  );
  useEffect(() => {
    const interval = setInterval(() => {
      setTimers(eventsData.map((ev) => getTimeLeft(ev.date)));
    }, 1000);

    return () => clearInterval(interval);
  }, []);
const getTimer=(timeLeft)=>{
  
  return (<div >{timeLeft.d > 0 || timeLeft.h > 0 || timeLeft.m > 0 ? (
    <span className="getTimerStyle"><Clock  size={20}/>  Starts in: {timeLeft.d}d {timeLeft.h}h {timeLeft.m}m {timeLeft.s}s</span>
  ) : (
    <span className="started getTimerStyle"><ArrowUpRightFromCircle  size={20}/> Event Started</span>
  )}</div>)
}

  return (<>
    <section className="upcoming-events">
      <h2>
        Upcoming Online <span>Events</span>
      </h2>
      <div className="events-container">
        {eventsData.map((event, index) => (
          
          <div key={index} className="event-card">
            <img src={event.image} alt={event.title} />
            <div className="event-body">
              <h3>{event.title}</h3>
              <p>
                Learn important concepts and strategies to take your career to
                the next level.
              </p>
              <div className="event-details-grid">
              <ul className="event-info">
                <li><Calendar size={16}  color={`rgba(144, 202, 249,1)`}/> {formatDate(event.date)}</li>
                <li><Watch  size={16}  color={`rgba(144, 202, 249,1)`}/> {event.time}</li>
               </ul> <ul className="event-info">
              <li><ParkingMeter  size={16}  color={`rgba(144, 202, 249,1)`}/> {event.duration}</li>
                <li><Laptop  size={16}  color={`rgba(144, 202, 249,1)`}/> {event.mode}</li>
              </ul></div>
              <div className="countdown">
  
  {getTimer(getTimeLeft(event?.date))}
</div>
              <button className="reserve-btn">Reserve Your Seat</button>
            </div>
          </div>
        ))}
      </div>
    </section>
    <style>{`.upcoming-events {
  padding: 60px 10%;
  text-align: center;
  background: #f8fcff;
  animation: fadeIn 0.6s ease-in-out;
}
  .getTimerStyle{display:flex;justify-content:left;gap:10px}
.event-details-grid{display:grid;grid-template-columns:50%  45% }
.upcoming-events h2 {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 40px;
}

.upcoming-events h2 span {
  color: rgba(144, 202, 249,1);
}

.events-container {
  display: flex;
  gap: 25px;
  justify-content: left;
  flex-wrap: wrap;
}

.event-card {
  width: 320px;
  background:rgba(144, 202, 249,0.1);
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  animation: slideUp 0.6s ease-in-out;
}

.event-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);
}

.event-card img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.event-body {
  padding: 18px;
  text-align: left;
}

.event-body h3 {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 8px;
}

.event-body p {
  font-size: 14px;
  color: #444;
  margin-bottom: 15px;
}
.countdown {
  background: rgba(144, 202, 249,0.31);
  color: #222222;
  font-size: 13px;
  font-weight: 600;
  padding: 6px 10px;
  border-radius: 6px;
  margin-bottom: 14px;
  display: inline-block;
}

.started {
  background: #fff3e0;
  color: #e67300;
  font-weight: 600;
  padding: 6px 10px;
  border-radius: 6px;
}

.event-info {
  list-style: none;
  padding: 0;
  margin: 0 0 15px;
  font-size: 14px;
  color: #333;
}

.event-info li { display:flex;justify-content:left;gap:10px;
  margin-bottom: 6px;
}

.reserve-btn {
  width: 100%;
  padding: 10px 0;
  background: rgba(144, 202, 249,1);
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: 0.3s;
}

.reserve-btn:hover {
  background: rgba(144, 202, 249,1);
}

/* Animations */
@keyframes fadeIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}

@keyframes slideUp {
  from { transform: translateY(20px); opacity: 0; }
  to   { transform: translateY(0); opacity: 1; }
}

/* Responsive */
@media (max-width: 768px) {
.upcoming-events {
  padding: 60px 10px;}
  .events-container {
    flex-direction: column;
    align-items: center;
  }
}
`}</style>
  </>);
};

export default EventCard1;
